import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { PanelFooter, PanelHeader } from 'components/Panel'

import './socios.css'
import { Offcanvas } from 'react-bootstrap'

function VerSocio(props) {
	const { socio, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver socio" />
			<Offcanvas.Body>
				<h1>Datos del socio</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{socio.id}</td>
								</tr>
								<tr>
									<th>Nombre</th>
									<td>{socio.nombre}</td>
								</tr>
								<tr>
									<th>Web</th>
									<td>{socio.web || '-'}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{socio.orden || '-'}</td>
								</tr>
							</tbody>
						</Table>
					</Col>
					<Col sm={12} md={6} className="text-center">
						<h3>Logo</h3>
						<div className="logo-img">
							<img src={socio.multimedia ? process.env.REACT_APP_API_URL + 'uploads/' + socio.multimedia.url : 'logo192.jpg'} alt={socio.nombre}/>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerSocio